import useGetItem from "./hooks/useGetItem";
import { useParams } from "react-router-dom";
import useUpdate from "./hooks/useUpdate";
import { GenericMethods } from "layouts/aplicacoes/GenericMethods";
import { Sites } from "data/utils/globals";
import { SchemaData } from "./hooks/types";
import { UpdateGql } from "./queries/update";
import { AdminUser } from ".";

function Update() {
  const id = useParams()?.id;

  if (!id) return null;

  return (
    <GenericMethods.Update<SchemaData, UpdateGql>
      siteId={Sites.UNIFTEC.id}
      sitePath={Sites.UNIFTEC.path}
      redirectPath="/configuracoes/usuarios"
      useGetItem={useGetItem}
      useUpdate={useUpdate}
      queryParam={id}
      hideDeleteButton
      updatePermission={AdminUser.Permissions.update}
    />
  );
}

export default Update;
